var scope_0 = require('/Users/fergusbisset/Dropbox/Sites/fb-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2a29d3172d9abb8d097e50c04d9e4c51.js').default;
var scope_1 = require('/Users/fergusbisset/Dropbox/Sites/fb-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5f65513e7546c8b4b6be5ccf06ce296d.js').default;
var scope_2 = require('/Users/fergusbisset/Dropbox/Sites/fb-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df305c04fc01eb47fda093e75afaadf7.js').default;
var scope_3 = require('/Users/fergusbisset/Dropbox/Sites/fb-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e60e1964f4ec8ec7678c1d9d00a13a9f.js').default;
var scope_4 = require('/Users/fergusbisset/Dropbox/Sites/fb-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_5 = require('/Users/fergusbisset/Dropbox/Sites/fb-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f2892927bc3a265db804f99e6af83db0.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    